import debug from 'debug'

const log = debug('app')

log('hi')

export default log
